import * as React from "react";
import { useContext, useMemo } from "react";
import WidgetFocusContext from "views/components/contexts/WidgetFocusContext";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import useWidgetActions from "views/components/widgets/useWidgetActions";
import { isWidgetMenuAction } from "views/components/widgets/Types";
const ExtraMenuWidgetActions = ({ widget }) => {
  const widgetFocusContext = useContext(WidgetFocusContext);
  const interactive = useContext(InteractiveContext);
  const pluginWidgetActions = useWidgetActions();
  const extraWidgetActions = useMemo(
    () => pluginWidgetActions.filter(isWidgetMenuAction).filter(({ isHidden = () => false }) => !isHidden(widget)).filter(({ showInNonInteractiveMode = false }) => interactive || showInNonInteractiveMode),
    [pluginWidgetActions, widget, interactive]
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, extraWidgetActions.map(({ component: Component, type, disabled = () => false }) => /* @__PURE__ */ React.createElement(
    Component,
    {
      widget,
      contexts: { widgetFocusContext },
      key: `${type}-${widget.id}`,
      disabled: disabled()
    }
  )));
};
export default ExtraMenuWidgetActions;
